import { SETTINGS_RESOURCES, SETTINGS_SCOPES, PAGE_NAMES } from 'constant';

export const makeActionList = (params: any) => {
	const { hasPermission } = params;
	return {
		rowActions: [
			{
				name: 'Edit',
				id: 'edit',
				isEnabled: () => {
					return hasPermission({
						entity: SETTINGS_RESOURCES.user,
						action: SETTINGS_SCOPES[SETTINGS_RESOURCES.user].editUser,
						configPageName: PAGE_NAMES.settings
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: SETTINGS_RESOURCES.user,
					action: SETTINGS_SCOPES[SETTINGS_RESOURCES.user].createUser,
					configPageName: PAGE_NAMES.settings
				});
			}
		}
	};
};

export default {
	makeActionList
};
